import './bar-chart-default.component.ajscss';

import { IComponentController, IComponentOptions, isNumber } from 'angular';
import * as d3 from 'd3';

class DefaultBarChartCtrl implements IComponentController {
  constructor(private readonly $element) {}

  $onChanges(changesObj) {
    d3.select(this.$element[0]).select('svg').remove();

    const container = d3.select(this.$element[0]);
    const margin = { top: 15, right: 10, bottom: 20, left: 40 };
    const width = container.node()['clientWidth'] - margin.left - margin.right;
    const height = container.node()['clientHeight'] - margin.top - margin.bottom;
    const data: any[] = [];
    const colors: any[] = [];
    const values = changesObj.data.currentValue;

    for (const value in values) {
      if (values.hasOwnProperty(value) && isNumber(values[value]) && values[value] >= 0) {
        data.push(values[value]);
        colors.push(value);
      }
    }

    const color = d3.scaleOrdinal().range(colors);

    const x = d3.scaleBand().rangeRound([0, width]);
    const y = d3.scaleLinear().range([height, 0]);

    const xAxis = d3.axisBottom(x);
    const yAxis = d3.axisLeft(y).ticks(10);

    const svg = container
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    x.domain(colors);
    y.domain([0, d3.max(data)]);

    svg
      .append('g')
      .attr('class', 'x axis')
      .attr('transform', 'translate(0,' + height + ')')
      .call(xAxis);

    svg.append('g').attr('class', 'y axis').call(yAxis);

    svg
      .selectAll('bar')
      .data(data)
      .enter()
      .append('rect')
      .style('fill', (_, i) => (color(i + '') + '').replace(';', ''))
      .attr('x', (_, i) => x(color(i + '') + '') ?? 0)
      .attr('width', x.bandwidth())
      .attr('y', d => y(d))
      .attr('height', d => height - y(d));
  }
}

export class DefaultBarChart implements IComponentOptions {
  bindings = {
    data: '<',
  };
  controller = ['$element', DefaultBarChartCtrl];
}

export default 'barChart';
